import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";

import { AnimatePresence, motion } from "framer-motion";
import { ReactComponent as BlankImg } from "../../assets/imgs/blankImg.svg";
import InfoDropdown from "../Fold2/InfoDropdown";

const FlexibleLinks = () => {
  const goToBenefits = () => {
    let element = document.getElementById("benefits");
    element.scrollIntoView({ behavior: "smooth" });
  };

  const dropdownList = [
    {
      id: 0,
      dropdownTitle: "Smart Dynamic Linking",
      title: "Route users intelligently based on device and app status",
      text: "Send users directly to your app if installed, to the App Store if not, or to a fallback web page—ensuring the journey continues smoothly regardless of device or platform.",
      learnMore: "",
    },
    {
      id: 1,
      dropdownTitle: "Deferred Deep Linking",
      title: "Continue the journey after install—without losing context",
      text: "Even after users install the app, they’ll land exactly where you intended. No broken paths or repeated steps—just seamless continuation.",
      learnMore: "",
    },
    {
      id: 2,
      dropdownTitle: "Custom Social Previews",
      title: "Control how your links appear on social and messaging platforms",
      text: "Customize link previews—title, image, and description—so your links look great and boost engagement wherever they're shared.",
      learnMore: "",
    },
    {
      id: 3,
      dropdownTitle: "Advanced Link Tracking",
      title: "Measure the full impact of every link",
      text: "Track installs, views, opens, reactivations, and time spent in the app for each individual link—giving you actionable data at every step.",
      learnMore: "",
    },
    {
      id: 4,
      dropdownTitle: "Google Analytics & UTM Support",
      title: "Add UTM and GA parameters to every link",
      text: "Easily attach UTM parameters and Google Analytics tracking IDs to monitor campaigns and performance from your dashboard.",
      learnMore: "",
    },
    {
      id: 5,
      dropdownTitle: "Fully Editable Links",
      title: "Update destinations anytime—even after the link is live",
      text: "Change redirects, preview settings, and metadata on any link after it’s been created. No need to regenerate or resend.",
      learnMore: "",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"flexibleLinks"}>
        <Line>
          <TextWrapper>
            <Title>Powerful, Flexible Links Built for Modern Apps</Title>
            <Subtitle>
              Deliver seamless user journeys across devices, track performance
              with precision, and stay in control with fully customizable and
              editable deep links. From social previews to post-install
              navigation, our Dynamic Links are designed to boost engagement and
              simplify every step of the user experience.
            </Subtitle>
          </TextWrapper>
        </Line>
        <AnimatePresence>
          <Line>
            <Column>
              {dropdownList.map((item) => (
                <InfoDropdown
                  key={item.id}
                  dropdownTitle={item.dropdownTitle}
                  title={item.title}
                  infoText={item.text}
                  learnMoreClick={item.learnMore}
                />
              ))}
            </Column>
          </Line>
        </AnimatePresence>
      </Container>
    </FullPageContainer>
  );
};

export default FlexibleLinks;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 80px 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};

  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
    align-items:center;
  width: 100%;
  gap: 16px;
`;
